import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { SyncService } from './sync.service';
import { saveAs } from 'file-saver';
import { AngularFirestore } from '@angular/fire/compat/firestore';


@Injectable({
	providedIn: 'root'
})
export class HttpService {
	private subscription: any;

	constructor(
		private http: HttpClient,
		private afStore: AngularFirestore,
		private syncService: SyncService,
	) {

		if (this.subscription) {
			this.subscription.unsubscribe();
		}

		this.syncService.page$.subscribe(page => {
			if (this.userData) {
				this.userData['Page'] = page;
			}
		});

		this.syncService.currentDeal$.subscribe(currentDeal => {
			this.currentDeal = currentDeal;
		});

		this.syncService.userData$.subscribe(userData => {
			this.userData = userData;
		});

		this.syncService.email.subscribe(email => {
			this.email = email;
		});
	}

	currentDeal = '';
	email = '';
	userData: any;

	private uploadUrl = environment.uploadUrl;

	deleteDeal(userData: any, dealPendingDeletion: string) {
		this.reloadUserData(false);
		userData['Deals'] = userData['Deals'].filter((deal: any) => deal['Deal Name'] !== dealPendingDeletion);
		this.syncService.updateUserData(userData); // DELETE DEAL
	}

	downloadFile(fileName:string, filesDocument: string): void {
		// @ts-ignore
		const formData: FormData = new FormData();
		formData.append('Files Document', filesDocument);
		this.syncService.updateShowSpinner(true);

		this.http.post(environment.downloadFilesUrl, formData, { responseType: 'blob' }).toPromise().then(response => {
			saveAs(response, fileName);
			this.syncService.updateShowSpinner(false);
		}, (error) => {
			console.log(error);
			this.syncService.updateShowSpinner(false);
			this.syncService.updateNotificationType('error');
			this.syncService.updateNotificationTitle('Error downloading file');
			this.syncService.updateNotificationSubtitle(error.message);
			this.syncService.updateShowNotification(true);
			setTimeout(() => {
				this.syncService.updateShowNotification(false);
			}, 5000);
		});
	}

	wakeUpServer(): void {
		const formData: FormData = new FormData();
		formData.append('Field', '000-Asset Name');
		formData.append('Value', 'Crescent Asia');
		formData.append('Page URL', 'https://firebasestorage.googleapis.com/v0/b/multiplai-test.appspot.com/o/demo%40multiplai.co__HW%20Nov%2019__Kallang%20%3E%202022-12-31_2022%20Q4%20Quarterly%20Portfolio%20Report.pdf__Page%200?alt=media');
		// @ts-ignore
		formData.append('Polygons Document', 'Zf9ueWTLW0At49IQrHnK');
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'multipart/form-data');
		this.http.post(environment.polygonUrl, formData, { headers, responseType: 'json' }).toPromise().then(response => {
			console.log('response', response);
		});
	}

	deleteFile(workspace: string, dealname: string, filename: string) {
		// @ts-ignore
		const formData: FormData = new FormData();
		formData.append('Workspace', workspace);
		formData.append('Deal Name', dealname);
		formData.append('File Name', filename);
		this.subscription = this.http.post(environment.deleteFileUrl, formData).toPromise().then(response => {
			// alert(workspace)
			// alert(dealname)
			// alert(filename)
			// alert(JSON.stringify(response))
		});
	}


	aggregate(dealData: any) {
		const emptyData = this.syncService.fileData.getValue()
		emptyData['Extracted Data'] = {}
		this.syncService.fileData.next(emptyData);
		// @ts-ignore
		const formData: FormData = new FormData();
		formData.append('Deal Data', JSON.stringify(dealData));

		let currentDeal = this.syncService.currentDeal.getValue();
		this.http.post(environment.aggregateUrl, formData, { responseType: 'json' }).toPromise().then(response => {
			// this.syncService.fileData.next(response);
			for (let i = 0; i < this.userData['Deals'].length; i++) {
				// @ts-ignore
				if (this.userData['Deals'][i]['Deal Name'] === this.currentDeal) {
					for (let j=0; j < this.userData['Deals'][i]['Files'].length; j++) {
						if (this.userData['Deals'][i]['Files'][j]['File Name'] === this.currentDeal + ' Compiled') {
							this.userData['Deals'][i]['Files'][j]['File Status'] = 'finished'
							// @ts-ignore
							this.userData['Deals'][i]['Files'][j]['Files Document'] = response['Files Document']
							this.syncService.updateUserData(this.userData);
							this.syncService.updateFileData(response);
						}
					}
				}
			}
			this.reloadUserData(false);
			return response
		}, (error) => {
			return error
			// this.syncService.updateNotificationType('error');
			// this.syncService.updateNotificationTitle('Error downloading files');
			// this.syncService.updateNotificationSubtitle(error.message);
			// this.syncService.updateShowNotification(true);
			// setTimeout(() => {
			// 	this.syncService.updateShowNotification(false);
			// }, 5000);
		});
	}


	downloadFiles(workspace: string, fundName: string): void {
		// @ts-ignore
		const formData: FormData = new FormData();
		formData.append('Workspace', workspace);
		formData.append('Fund Name', fundName);
		this.syncService.updateShowSpinner(true);

		this.http.post(environment.downloadFundFilesUrl, formData, { responseType: 'blob' }).toPromise().then(response => {
			const zipFileName = `${fundName}.zip`;
			saveAs(response, zipFileName);
			this.syncService.updateShowSpinner(false);
		}, (error) => {
			console.log(error);
			this.syncService.updateShowSpinner(false);
			this.syncService.updateNotificationType('error');
			this.syncService.updateNotificationTitle('Error downloading files');
			this.syncService.updateNotificationSubtitle(error.message);
			this.syncService.updateShowNotification(true);
			setTimeout(() => {
				this.syncService.updateShowNotification(false);
			}, 5000);
		});
	}

	async reloadUserData(verbose: boolean = true) {
		try {
			this.subscription.unsubscribe();
		} catch (error) {}
		const snapshot = await this.afStore.collection(
			'Users', ref => ref.where('Workspace', '==', this.userData['Workspace']),
		).snapshotChanges();
		this.subscription = snapshot.subscribe(docs => {
			const userDoc = docs[0].payload.doc;
			this.userData = userDoc.data();
			// this.userData['Email'] = this.email;
			this.userData['Page'] = this.syncService.page.getValue();
			try {
				this.subscription.unsubscribe();
			} catch (error) {}

			this.userData['Deals'].forEach((deal: any) => {
				deal['Files'].forEach((file: any) => {
					// if (file['File Status'] !== 'finished') {
					// 	alert(file['File Status'])
					// }
					if (file['File Status'] !== 'finished') {
						const fileSnapshot = this.afStore.collection(
						  'Files', ref => ref
								.where('Workspace', '==', this.userData['Workspace'])
								.where('Deal Name', '==', deal['Deal Name'])
								.where('File Name', '==', file['File Name'])
								.where('File Status', 'in', ['finished', 'error'])
						).snapshotChanges();
						fileSnapshot.subscribe(docs => {
							docs.sort((a, b) => {
								// @ts-ignore
							  	return b['Timestamp'] - a['Timestamp'];
							});
							docs.forEach(doc => {
								const _file = doc.payload.doc.data();
								// @ts-ignore
								console.log(file['Timestamp'], _file['Timestamp'])
								// @ts-ignore
								if (_file['Timestamp'] === file['Timestamp'] || !('Timestamp' in file)) {
									// @ts-ignore
									file['Files Document'] = _file['Files Document']
									// @ts-ignore
									// alert(_file['File Status']);
									// @ts-ignore
									file['File Status'] = _file['File Status'];
									// @ts-ignore
									file['Timestamp'] = _file['Timestamp'];

									// @ts-ignore
									if (_file['Error']) {
										// @ts-ignore
										file['Error'] = _file['Error'];
									}

									// if (_file['File Status'] === 'finished' && _file['Pages'] && _file['Extracted Data']) {
									// 	file['File Status'] = 'finished';
									// 	// alert(file['File Status'])
									// }
									this.syncService.updateUserData(this.userData); // RELOAD USER DATA
								}
							});
						});
					}
				});
			});
			if (verbose) {
				this.syncService.updateNotification('success', 'Status Update Complete', 'Dashboard now displays the most recent file processing status.');
			}
			try {
				this.subscription.unsubscribe();
			} catch (error) {}
		});
	}

	processFile(file: any, currentDeal: string) {
		const timestamp = new Date().getTime().toString();

		console.log('processFile function called with:', file, currentDeal, timestamp);

		const newFile = {
			'File Name': file.file.name,
			'File Status': 'active',
			'File Types': file['File Types'],
			'Timestamp': timestamp,
			'Deal Name': currentDeal,
			'Reference Date': file['Reference Date'],
		};
		for (let i = 0; i < this.userData['Deals'].length; i++) {
			if (this.userData['Deals'][i]['Deal Name'] === currentDeal) {
				this.userData['Deals'][i]['Files'].unshift(newFile);
				this.syncService.updateUserData(this.userData); // PROCESS FILE
			}
		}

		const formData: FormData = new FormData();
		formData.append('File', file.file, file.file.name);
		formData.append('Workspace', this.userData['Workspace']);
		formData.append('Deal Name', currentDeal);
		formData.append('File Types', file['File Types'].join('|'));
		formData.append('Timestamp', timestamp);
		formData.append('User Email', this.email);

		// alert(this.uploadUrl)
		this.syncService.updateNotification('success', 'Submission Successful', 'Processing underway. Please check back in 30 minutes.');

		this.subscription = this.http.post(this.uploadUrl, formData).toPromise().then(response => {
			this.reloadUserData(false);
			// this.syncService.updateNotifySuccess(true);
			// @ts-ignore
			if (response['File Status'] === 'queued') {
				// @ts-ignore
				this.syncService.updateNotification('success', 'File Added to Queue', response['File Name'] + ' will be processed shortly.')
			} else {
				// @ts-ignore
				this.syncService.updateNotification('success', 'File Analysis Complete', response['File Name'] + ' is ready for your review.')
			}
			if (this.subscription) {
				this.subscription.unsubscribe()
			}
		}).catch(error => {
			error = error["error"]
			this.reloadUserData(false);
			this.syncService.updateNotification('error', 'File Processing Error', error['Error']);
			if (this.subscription) {
				this.subscription.unsubscribe()
			}
		});
	}

	reprocessFile(fileData: any, timestamp: string) {
		const formData: FormData = new FormData();
		formData.append('File Name', fileData['File Name']);
		formData.append('Workspace', this.userData['Workspace']);
		formData.append('Deal Name', fileData['Deal Name']);
		formData.append('File Types', fileData['File Types']);
		formData.append('Reference Date', fileData['Reference Date']);
		formData.append('Files Document', fileData['Files Document']);
		formData.append('Timestamp', timestamp);
		formData.append('User Email', this.email);

		// alert(environment.reUploadUrl)
		this.syncService.updateNotification('success', 'Submission Successful', 'Processing underway. Please check back in 30 minutes.');

		this.subscription = this.http.post(environment.reUploadUrl, formData).toPromise().then(response => {
			this.reloadUserData(false);
			// @ts-ignore
			if (response['File Status'] === 'queued') {
				// @ts-ignore
				this.syncService.updateNotification('success', 'File Added to Queue', response['File Name'] + ' will be processed shortly.')
			} else {
				// @ts-ignore
				this.syncService.updateNotification('success', 'File Analysis Complete', response['File Name'] + ' is ready for your review.')
			}
			if (this.subscription) {
				this.subscription.unsubscribe()
			}
		}).catch(error => {
			error = error["error"]
			this.reloadUserData(false);
			this.syncService.updateNotification('error', 'File Processing Error', error['Error']);
			if (this.subscription) {
				this.subscription.unsubscribe()
			}
		});
	}
}
